import { sanitizeCampaignEdges } from "@signalist/shared-types";

interface SanitizableEdge {
	source: string;
	target: string;
}

interface SanitizableNode {
	id: string;
}

/**
 * Strips invalid edges from a campaign's edge list:
 * - Self-loops (source === target) are never valid in a DAG-like campaign graph.
 * - Zombie edges referencing nodes that no longer exist (left-over from prior deletions).
 *
 * One rule with the API's structure lock (`campaignLockFingerprint`, PREC-4616): what the builder
 * drops on load must not read as a structural change there.
 */
export function sanitizeEdges<E extends SanitizableEdge>(
	edges: E[],
	nodes: SanitizableNode[]
): E[] {
	return sanitizeCampaignEdges(edges, nodes);
}
